import React, { useState } from 'react';
import { ArrowLeft, X, ZoomIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const FullGallery = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);

  const handleBookingClick = () => {
    navigate('/', { state: { scrollTo: 'contact' } });
  };

  const images = [
    {
      url: 'https://static.wixstatic.com/media/5924bc_148da214afbf4252918ecb719a65d375~mv2.jpg/v1/fill/w_800,h_521,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202025-12-13%20at%2014_03_edited.jpg',
      title: 'Side Ramp / Loading',
      description: 'Lightweight barn door style ramp with extra thick rubber'
    },
    {
      url: 'https://static.wixstatic.com/media/5924bc_588e918cf7e5495ebbdd1a760195a68d~mv2.jpg/v1/fill/w_444,h_606,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/WhatsApp%20Image%202025-12-13%20at%2014_03_edited.jpg',
      title: 'Front View',
      description: 'Renault Master 3.5-ton professional horsebox'
    },
    {
      url: 'https://static.wixstatic.com/media/5924bc_cc9593d1d7a54e7bbeb5be5cef6c7ae5~mv2.jpeg/v1/fit/w_1440,h_612,q_90,enc_avif,quality_auto/5924bc_cc9593d1d7a54e7bbeb5be5cef6c7ae5~mv2.jpeg',
      title: 'Side View',
      description: 'Built by Foxy Horseboxes to exceptional standards'
    },
    {
      url: 'https://static.wixstatic.com/media/5924bc_54df50bde30c475eb1c33c2297ca57d6~mv2.jpeg/v1/fit/w_1440,h_612,q_90,enc_avif,quality_auto/5924bc_54df50bde30c475eb1c33c2297ca57d6~mv2.jpeg',
      title: 'Barn Door View',
      description: 'Spacious and comfortable interior for your horse'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/8tbf1vlj_WhatsApp%20Image%202025-12-13%20at%2014.03.09.jpeg',
      title: 'Side Ramp',
      description: 'Safe and comfortable loading for your horse'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/wwz7n5i3_WhatsApp%20Image%202025-12-13%20at%2014.03.11%20%281%29.jpeg',
      title: 'Stallion Stall',
      description: 'Well ventilated and secure travel for your horse'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/lgh6hsry_WhatsApp%20Image%202025-12-13%20at%2014.03.12%20%281%29.jpeg',
      title: 'Groom Area',
      description: 'Comfortable seating and storage space'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/lqfmqgtf_WhatsApp%20Image%202025-12-13%20at%2014.03.12%20%283%29.jpeg',
      title: 'Tack Storage',
      description: 'Includes two saddle racks and hanging space'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/1xxivql1_WhatsApp%20Image%202025-12-13%20at%2014.03.14%20%281%29.jpeg',
      title: 'Spacious Cab',
      description: 'Easy to drive with room for 3 people'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/ovtjwg6k_WhatsApp%20Image%202025-12-13%20at%2014.03.15%20%282%29.jpeg',
      title: 'Rubber Matting',
      description: 'Reinforced and secure flooring'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/uhq4n9o2_WhatsApp%20Image%202025-12-13%20at%2014.03.16%20%281%29.jpeg',
      title: 'Rear Door Access',
      description: 'Emergency access through the rear door'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_equigo-redesign/artifacts/8nbmfkw1_WhatsApp%20Image%202025-12-13%20at%2014.03.16.jpeg',
      title: 'Stalled for Two Horses',
      description: 'Maximum total payload of 1,050kg'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm py-4">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center space-x-4">
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-[#2d5f3f] text-[#2d5f3f] hover:bg-[#2d5f3f] hover:text-white"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
            <img
              src="https://static.wixstatic.com/media/5924bc_1d4a840f9cb44afcb7ee8f647411679d~mv2.png/v1/fill/w_212,h_93,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/5924bc_1d4a840f9cb44afcb7ee8f647411679d~mv2.png"
              alt="Equi-Go Logo"
              className="h-12 w-auto"
            />
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-['Playfair_Display']">
              Horsebox <span className="text-[#2d5f3f]">Gallery</span>
            </h1>
            <p className="text-lg text-gray-600">
              Take a closer look at our state-of-the-art Foxy Horsebox. Click any image to view full size.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {images.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedImage(image)}
              >
                <div className="aspect-[4/3] overflow-hidden bg-gray-200">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <h3 className="text-2xl font-bold mb-2">{image.title}</h3>
                    <p className="text-sm text-white/90">{image.description}</p>
                  </div>
                  <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                    <ZoomIn className="w-5 h-5 text-white" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center bg-gradient-to-br from-[#2d5f3f] to-[#1e4029] rounded-2xl p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">Ready to Book?</h3>
            <p className="text-white/90 mb-6 text-lg">Contact us to check availability and make a booking</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={handleBookingClick}
                className="inline-flex items-center justify-center px-8 py-3 bg-white text-[#2d5f3f] hover:bg-gray-100 rounded-lg transition-colors duration-300 font-semibold text-base w-full sm:w-auto h-[48px]"
              >
                Go to Booking Form
              </button>
              <a
                href="tel:07788754165"
                className="inline-flex items-center justify-center px-8 py-3 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg hover:bg-white/20 transition-colors duration-300 font-semibold text-base w-full sm:w-auto h-[48px]"
              >
                Call 07788 754165
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm hover:bg-white/20 flex items-center justify-center transition-colors duration-300 group"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          
          <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg shadow-2xl"
            />
            <div className="mt-6 text-center text-white">
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              <p className="text-white/80">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FullGallery;